class jyContent {
  constructor () {
    this.init()
  }
  
  init () {
    //调用 nanoScroller.js
    $(".nano").nanoScroller({preventPageScrolling: true})
    $(window).resize(function () {
      if (window.matchMedia('(max-width: 1155px)').matches) {
        $('#about').removeClass('nano');
      } else {
        $('#about').addClass('nano');
      }
    }).trigger('resize');
    
    //克隆面对的预告片到侧边导航
    var md_video = $('#pageThreeTrailer .trailer-content').clone();
    $('#slide-nano').append(md_video);
    
    //lity 视频播放功能
    var videoItems = $('section[id^="page-"]').find('.js-video-item');
    
    //delegate
    //videoItems
    /*$(document).delegate('section[id^="page-"] .js-video-item', 'click', function (ev) {
      window.setTimeout(() => {
        var videoId = $(this).data('video-id');
        //  判断是 youtube 还是 Vimeo
        let res = videoId.match(/^\d+$/)
        if (res) {  //  vimeo
          window.__lity = window.lity(`https://vimeo.com/${videoId}`);
        } else {  //  youtube
          window.__lity = window.lity(`https://www.youtube.com/watch?v=${videoId}`)
        }

        if ($(this).hasClass('hideList')) {
          $('.lity #button-arrow').addClass('hide')  //取消更多视频侧边栏
        } else {
          /!*if (window.audioMethod) {
            window.audioMethod.pause()  // 暂停音乐播放
          }*!/
        }
      },200)


    });*/
    //PC 端【预告片】lity 侧滑导航视频切换
    /*  $(document).on('click', '#slide-center .js-video-item', ev => {
        let el = ev.currentTarget
        let videoId = el.dataset.videoId
        let iframe = $('.lity-iframe-container').children('iframe')
        let src = $(iframe).attr('src')
        //  通过修改iframe上的src达到切换效果
        // https://www.youtube.com/embed/FL-mPfPCpB0?autoplay=1&rel=0
        $(iframe).attr('src', src.replace(/embed\/(.*?)\?/i, `embed/${videoId}`))
  
      });*/
    
    var mobile = false;
    /* $(document).on('lity:open', function (event, instance) {
       //克隆元素添加给lity 弹出框 侧边栏导航时用
       var slide_nav = $('#slide-center').clone().removeClass('hide');
       var slide_btnarraw = $('#button-arrow').clone().removeClass('hide');
       //添加展示图片
 
       slide_nav.find('img').map(function () {
         var dataSrc = $(this).attr('data-src');
         $(this).attr('src', dataSrc)
       })
 
       //lity 添加侧边导航
       $('.lity .lity-wrap').append(slide_nav, slide_btnarraw);
       var slide_center = $('.lity-wrap #slide-center');
       //打开预告片侧边栏
       $('#button-arrow .expand').on('click', ev => {
         slide_center.addClass('active');
       });
       //收起预告片侧边栏
       $('.lity-wrap #slide-center').find('.slide-close').on('click', ev => {
         slide_center.removeClass('active');
       });
       //打开lity 关闭禁止横屏
       $('#jy-screen').addClass('hide');
       //移动端lity 框视频分享
       var lityShare = $('#lity-share').removeClass('hide');
 
       //打开弹框关闭背景音乐
       var AudioBtn = $('.audio-ctrl');
       //var unmuteImg  = AudioBtn.data('unmute')
       var muteImg  = AudioBtn.data('mute')
       if(window.player){
           window.player.mute()
           AudioBtn.children('img').attr('src',muteImg)
           AudioBtn.removeClass('ft');
       }
       
     });*/
    
    /*$(document).on('lity:remove', function (event, instance) {
      //关闭lity 打开禁止横屏功能
      $('#jy-screen').removeClass('hide');
      $('#lity-share').addClass('hide')
      if (window.audioMethod) {
        window.audioMethod.play()
      }
    });*/
    
    //适用于手机端的屏幕判断
    window.addEventListener("orientationchange", function () {
      if (window.orientation === 180 || window.orientation === 0) {
        $('#jy-screen').fadeOut();
        orientation = 'portrait';
        return false;
      } else if (window.orientation === 90 || window.orientation === -90) {
        $('#jy-screen').fadeIn();
        orientation = 'landscape';
        return false;
      }
    }, false);
    
    //处理中文简介标题
    var Gradient = $('#introduct .gradient-text')
    if (Gradient.hasClass('letter')) {
      var TextLength = $('#introduct .gradient-text').text();
      Gradient.html(TextLength[0] + '&nbsp;&nbsp;&nbsp;&nbsp;' + TextLength[1])
    }
    
    
    //适用于PC端的屏幕判断
    $(window).resize(ev => {
      var WinWidth = $(window).innerWidth();
      var WinHeight = $(window).innerHeight();
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        WinWidth >= WinHeight ? $('#jy-screen').fadeIn() : $('#jy-screen').fadeOut();
      } else {
        $('#jy-screen').fadeOut();
      }
      
    }).trigger('resize');
 
    // 在每个页面生成【观看正片】【向上、向下滑動（移动端/PC端）】按钮
    var watchPost = $('.watch-posit').clone().removeClass('hide');
    var arrwDown = $('.arrw-down').clone().removeClass('hide');
    var scroll_bottom = $('.scroll-bottom').clone().removeClass('hide');
    var slideBtnBotm = $('.jy-slide-btn-bottom').clone().removeClass('hide');
    var slideBtnTop = $('.jy-slide-btn-top').clone().removeClass('hide');
    
    $("section[id^='page-']").append(watchPost, arrwDown, slideBtnBotm, slideBtnTop);
    $("#page-1").find('.jy-slide-btn-top').addClass('hide').end().find('.watch-posit').removeClass('hidden-sm hidden-xs');
    $("#page-1").find('.arrw-down').children('img').before(scroll_bottom);
    
    //鼠标滑过首屏的【观看正片】时【向上、向下滑動】按钮隐藏
    $('#page-1').find('.watch-posit').hover(function () {
      $('.jy-slide-btn-bottom').css({'transform': 'scale(0)', 'transition': '0.3s'});
    }, function () {
      $('.jy-slide-btn-bottom').css({'transform': 'scale(1)', 'transition': '0s'});
    });
    
    //  调用首页视频
    this.callBgVideo()
    //  处理视频切换暂停问题
    this.handleVideoChangePause()
    //  处理首页隐藏显示banner
    this.handleShowHideBanner()
    //  处理向上滑动与向下滑动按钮
    this.handleScrollTopWithBtn()
    //移动端lity 框视频分享
    this._mobileShareVideo()
    //调用开场动画
    this._animation()
    
    // 处理首屏背景视频声音播放暂停
    this._GetPlayerState()
    
    //简介展开收起处理
    this._IntroductionShowHide()

    //预告片当前播放视频加Heightlight
    //this._SlideVideolistActive()
    
    //字体加投影
    this.hackPageShadowTitle()
    
    //【向上、下滑动按钮】位置
    this.mouseMovePositionChange()
  }
  
  handleScrollTopWithBtn () {
    $('.jy-slide-btn-top').on('click', ev => $.fn.fullpage.moveSectionUp())
    $('.jy-slide-btn-bottom, .arrw-down').on('click', ev => $.fn.fullpage.moveSectionDown())
  }
  
  handleShowHideBanner () {
    window.__firstPageBannerShow = true
    
    $(window).on('videoCurrentTimeChange', (ev, obj) => {
      let currentTime = obj.currentTime
      let min = 48.00
      let max = 62.00
      
      if (Math.floor(currentTime) == 2) {
        $('#logo, .post-title').addClass('active')
      }
      if (window.__firstPageBannerShow && min < currentTime) {
        // $('').velocity()  todo 执行隐藏
        $('#logo, .post-title').removeClass('active');
        //window.__firstPageBannerShow = false
      }
      
    })
  }
  
  callBgVideo () {
    window.__isCallVgVideo = false
    $(window).on('onYouTubeIframeAPIReady', () => {
      
      if (window.innerWidth > window.gp_max_md && !window.__isCallVgVideo) {
        this._callBgVideo()
        //处理第一屏背景视频
        this.PageOneBackgroundVideo()
      }
      
      if (true) {
        var sec3Bgc = $('#page-5').find(BgcVideo);
        var sec3Vid = sec3Bgc.data('video-id');
        this.__initBackgroundVideo(sec3Bgc, sec3Vid, false, 'fifth', 5, 1)
      }
      
    })
    var BgcVideo = $('.background-video');
    var page1Video = $('.video-background-video');
    $(window).resize(ev => {
      if (window.innerWidth > window.gp_max_md && window.__ytbIsReady && !window.__isCallVgVideo) {
        this._callBgVideo()
        //处理第一屏背景视频
        this.PageOneBackgroundVideo()
        
      } else if (window.innerWidth > window.gp_max_md) {
        BgcVideo.removeClass('hide')
        page1Video.removeClass('hide')
      } else {
        BgcVideo.addClass('hide')
        page1Video.addClass('hide')
        $('#page-5 .background-video').removeClass('hide')
      }
    })
  }
  
  _callBgVideo () {
    let BgcVideo = $('.background-video');
    window.__isCallVgVideo = true
    
    var sec2Bgc = $('#page-2').find(BgcVideo);
    var sec2Vid = sec2Bgc.data('video-id');
    // this.__BackVideo(sec3Bgc, sec3Vid)
    // this.__BackVideo(sec1Bgc, sec1Vid, true)
    // this.__BackVideo(sec2Bgc, sec2Vid)
    !window.__isLoaded && window.loadingBar.animate(0.55)
    this.__initBackgroundVideo(sec2Bgc, sec2Vid, false, 'second', 2)
  }
  
  __initBackgroundVideo (bg, video, trueOrFalse, section, num, isMute = 0) {
    //  判断根据屏幕区分加载
    //  //G2_afterRender
    //
    $(window).on('G2_onLeave', ev => {
      
      if (ev.nextIndex == num && !window[`__${section}_init`]) {
        this.__BackVideo(bg, video, trueOrFalse, isMute)
        window[`__${section}_init`] = true
      }
      if(ev.nextIndex == num){
          let oYtPlayer = $(`#page-${num}`).find('.background-video').data('ytPlayer')
          if (oYtPlayer) {
            setTimeout(() => {
                oYtPlayer.player.playVideo && oYtPlayer.player.playVideo()
            },200)
          }
      }
    })
    
    //  加载进入
    if (window.location.hash == "") {
      this.__BackVideo(bg, video, trueOrFalse, isMute)
    } else if (window.location.hash == `#${section}`) {
      
      this.__BackVideo(bg, video, trueOrFalse, isMute)
      if (!window[`__${section}_init`]) {
        if (window.__fullPageInitEd) {  //  判断fullpage是否已经初始化了
          this.__BackVideo(bg, video, trueOrFalse, isMute)
          window[`__${section}_init`] = true
        } else {
          $(window).on('G2_afterRender', ev => {
            this.__BackVideo(bg, video, trueOrFalse, isMute)
            window[`__${section}_init`] = true
          })
        }
      }
    }
    
    //  延迟加载
    window.setTimeout(() => {
      this.__BackVideo(bg, video, trueOrFalse)
      window[`__${section}_init`] = true
    }, window.gp_load_all)
  }
  
  __BackVideo (roundObj, videoId, listenCurrentTime, isMute = 0) {
    roundObj.YTPlayer({
      listenCurrentTime: listenCurrentTime,
      videoId: videoId,
      fitToBackground: true,
      pauseOnScroll: true,
      repeat: true,
      playerVars: {
        modestbranding: 0,
        autoplay: 1,
        controls: 1,
        showinfo: 0,
        branding: 0,
        mute: isMute,
        rel: 0,
        autohide: 0
      }
    })
  }
  
  
  handleVideoChangePause () {
    $(window).on('G2_onLeave', ev => {
      let oYtPlayer = $(`#page-${ev.nextIndex}`).find('.background-video').data('ytPlayer')
      if (oYtPlayer) {
        oYtPlayer.player.playVideo && oYtPlayer.player.playVideo()
      }
    })
  }
  
  _mobileShareVideo () {
    /*    var LityShare = $('.lity-share').clone().removeClass('hide');
        $(document).on('click', '.js-video-item', function () {
          if(window.matchMedia('(max-width: 1155px)').matches){
            setTimeout(function(){
              var IframeSrc = $('.lity .lity-iframe-container').find('iframe').attr('src');
              LityShare.attr('data-a2a-url',IframeSrc)
              $('.lity .lity-container').append(LityShare)
              $('.lity-share span, .lity-share a').velocity('transition.slideUpIn', { stagger: 80 });
              $('.lity .lity-container').append('<script async src="https://static.addtoany.com/menu/page.js"></script>');
            },500)
          }
        });*/
    var onlineTitle = $.trim($('.post-title').data('online-title'));
    $('.watch-posit').find('a').attr('href') !== '' ? $('.post-title').html(`<span>${onlineTitle}</span>`) : $('.watch-posit').addClass('hide');
    
  }
  
  _animation () {
    //处理开场动画
    //todo it
    var toAnimat = true;
    $(window).on('loadingEffectEnd', function () {
      setTimeout(function () {
        $('.watch-posit').removeClass('active').fadeIn(8000).addClass('active')
        if (toAnimat) {
          $('section[id^="page-"].active').find(".jy-vel-amint").velocity('transition.slideUpBigIn', {stagger: 80});
        }
        toAnimat = false;
      }, 100)
      
    })
    
    $(window).on('G2_onLeave', ev => {  //简介页面动效
      
      $(".jy-vel-amint").velocity('finish').velocity({opacity: 0}, {display: 80})
    })
    $(window).on('G2_afterLoad', ev => {  //简介页面动效
      var DataAnchor = '#' + $(`#page-${ev.index}`).data('anchor');
      
      if (ev.nextindex == 1) {
        $('.watch-posit').removeClass('active').fadeIn(5000).addClass('active')
        
      }
      if (DataAnchor == window.location.hash) {
        $(`#page-${ev.index}`).find(".jy-vel-amint").velocity('transition.slideUpBigIn', {
          stagger: 80
        })
      }
      
    })
  }
  
  PageOneBackgroundVideo () {
    //$(window).on('onYouTubeIframeAPIReady', () => {
    var player;
    var videoId = $('#video-wrapper').data('video-id')
    window.player = new YT.Player('video-wrapper', {
      videoId: videoId,
      ratio: 16 / 9,
      repeat: true,
      width: $(window).width(),
      playerVars: {
        'iv_load_policy': 3,
        'modestbranding': 1,
        'autoplay': 1,
        'mute': 1,
        'controls': 0,
        'showinfo': 0,
        'wmode': 'opaque',
        'branding': 0,
        'autohide': 0,
        'rel': 0,
        'showinfo': 0
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
    
    function onPlayerReady (event) {
      //event.target.mute();
      event.target.setVolume(50);
      window.setInterval(() => {
        $(window).trigger('videoCurrentTimeChange', {
          currentTime: event.target.getCurrentTime()
        })
      }, 100)
      
      setTimeout(function () {
        !$('.audio-ctrl').hasClass('ft') && $('.audio-ctrl').click()
        if (window.__fix_autoplay_video) {
          event.target.playVideo()
          !$('.audio-ctrl').hasClass('ft') && $('.audio-ctrl').click()
        }
      }, 200)
      
    }
    
    function onPlayerStateChange (event) {
      if (event.data === 1) {
        !window.__isLoaded && window.loadingBar.animate(1)
      }
      if (event.data === 0) {
        
        event.target.playVideo();
      }
      
      if (event.data === 2) {
        window.__fix_autoplay_video = true
      }
    }
    
    //})
  }
  
  _GetPlayerState () {
    var AudioBtn = $('.audio-ctrl');
    var muteImg = AudioBtn.data('mute')
    var unmuteImg = AudioBtn.data('unmute')
    AudioBtn.on('click', function () {
      $(this).toggleClass('ft')
      if ($(this).hasClass('ft') && window.player) {
        window.player.mute()
        $(this).children('img').attr('src', muteImg)
      } else {
        window.player.unMute()
        $(this).children('img').attr('src', unmuteImg)
      }
    });
  }
  
  _IntroductionShowHide () {
    var NanoHeit = $('#introduct .nanoscroll').height()
    $('#page-2 .read-more').on('click', function () {
      window.setTimeout(() => {
        $.fn.fullpage.reBuild()
      }, 200)
      
      $(this).toggleClass('in');
      if ($(this).hasClass('in')) {
        $(this).text(window.introduct.hideMore);
        $('#introduct .nanoscroll').addClass('showMore')
        $('#introduct .nanoscroll p, .read-more').velocity('transition.slideUpBigIn', {stagger: 80})
      } else {
        $(this).text(window.introduct.showMore);
        $('#introduct .nanoscroll').removeClass('showMore');
        $('#page-2 .tab-logo, .introud-right h4, .read-more, #introduct .nanoscroll p').velocity('transition.slideUpBigIn', {stagger: 80});
      }
      $('#introduct .nanoscroll').toggleClass('active-mask')
    })
  }
  hackPageShadowTitle () {
    let watchPositTitle = $('.watch-posit span').html();
    let postTitle1 = $('.post-title span').eq(0).html();
    let postTitle2 = $('.post-title span').eq(1).html();
    let md_fptt_title = $('.f-p-t-t p').html();
    let focusPoint3Title = $('#page-5 .focus-point-title').html()
    $('head').append(`
     <style id="jy-page-title">
      .watch-posit span::after{
        content:"${watchPositTitle}";
      }
      .post-title span:nth-of-type(1)::after {
         content: "${postTitle1}";
      }
      .post-title span:nth-of-type(2)::after {
        content: "${postTitle2}";
      }
      .f-p-t-t p::after {
        content: "${md_fptt_title}";
      }
      #page-5 .focus-point-title::after{
        content:"${focusPoint3Title}";
      }
     </style>
    `)
    
  }
  mouseMovePositionChange(){

    //上下屏切换幽灵按钮处理
    var winWidth = window.innerWidth;
    var winHeight = window.innerHeight;
    var BodyWidth = document.body.clientWidth;
    
    //兼容火狐获取鼠标坐标
    
    
    function mouseCoords (ev) {
      ev = ev || window.event;
      if (ev.pageX || ev.pageY) {
        return {x: ev.pageX, y: ev.pageY};
      }
      return {
        x: ev.clientX + document.body.scrollLeft - document.body.clientLeft,
        y: ev.clientY + document.body.scrollTop - document.body.clientTop
      };
    }
    
    
    $('.section').on('mousemove', function (ev) {
      
      ev = ev || window.event;
      
      if (window.matchMedia('(min-width: 1921px)').matches) {
        if (mouseCoords(ev).x > (winWidth - BodyWidth) / 2 + 260 && mouseCoords(ev).x < BodyWidth + (winWidth - BodyWidth) / 2 - 260 && mouseCoords(ev).y < 100) {
          eventClienMin1920(this, '.jy-slide-btn-top', mouseCoords(ev).x, mouseCoords(ev).y)
        } else if (mouseCoords(ev).x > (winWidth - BodyWidth) / 2 + 260 && mouseCoords(ev).x < BodyWidth + (winWidth - BodyWidth) / 2 - 260 && (winHeight - mouseCoords(ev).y) < 100) {
          eventClienMin1920(this, '.jy-slide-btn-bottom', mouseCoords(ev).x, mouseCoords(ev).y)
        } else {
          $('.jy-slide-btn-top').addClass('active-out').removeClass('active');
          $('.jy-slide-btn-bottom').addClass('active-out').removeClass('active');
        }
      } else {
        if (mouseCoords(ev).x > 260 && mouseCoords(ev).x < (winWidth - 260) && mouseCoords(ev).y < 100) {
          eventClien(this, '.jy-slide-btn-top', mouseCoords(ev).x, mouseCoords(ev).y)
        } else if (mouseCoords(ev).x > 260 && mouseCoords(ev).x < (winWidth - 260) && (winHeight - mouseCoords(ev).y) < 100) {
          eventClien(this, '.jy-slide-btn-bottom', mouseCoords(ev).x, mouseCoords(ev).y)
        } else {
          $('.jy-slide-btn-top').addClass('active-out').removeClass('active');
          $('.jy-slide-btn-bottom').addClass('active-out').removeClass('active');
        }
      }
    })
    
    //计算【向上、下滑动按钮】位置
    function eventClien (thant, slideBtn, pageX, pageY) {
      $(thant).find(slideBtn).removeClass('active-out').addClass('active');
      $(thant).find(slideBtn).css('left', (pageX - 57) + "px");
      $(thant).find(slideBtn).css('top', (pageY - 57) + "px");
    }
    
    //屏幕大于1920px
    function eventClienMin1920 (thant, slideBtn, pageX, pageY) {
      $(thant).find(slideBtn).removeClass('active-out').addClass('active');
      $(thant).find(slideBtn).css('left', (pageX - (winWidth - BodyWidth) / 2 - 57) + "px");
      $(thant).find(slideBtn).css('top', (pageY - 57) + "px");
    }
  }
  
}


export default jyContent
